import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';


dayjs.extend(relativeTime);


/**
 * Format link block to url.
 * @param {object} data
 * @returns {string}
 */
export const formatLinkBlockToUrl = (data) => {
    const linkTo = data?.linkTo;
    let url = null;
    switch (linkTo) {
    case 'email':
        url = 'mailto:' + data[linkTo];
        break;
    case 'anchor':
        url = '#' + data[linkTo];
        break;
    case 'custom_url':
        url = data?.customUrl;
        break;
    case 'file':
        url = data[linkTo]?.url;
        break;
    case 'page':
        url = data[linkTo]?.url;
        break;
    case 'phone':
        url = 'tel:' + data[linkTo];
        break;
    }

    return url;
};

/**
 * Get display name for calendar listing item type
 * @param {string} itemType
 * @returns {string}
 */
export const getPrettyItemTypeName = (itemTypeName) => {
    return itemTypeName.replace('DetailPage', '');
};

/**
 * Format calendar listing item time
 * @param {string} itemType
 * @param {Date} itemTimeStart
 * @param {Date} itemTimeEnd
 * @returns {string}
 */
export const formatCalendarListingItemTime = (itemType, itemTimeStart, itemTimeEnd) => {
    if (!itemType && !itemTimeStart && !itemTimeEnd) {
        return '';
    }

    const end = dayjs(itemTimeEnd);
    const start = dayjs(itemTimeStart);

    if (itemType === 'AnnouncementDetailPage') {
        return start.format('ddd, D MMM YYYY');
    }

    if (itemType === 'EventDetailPage' || itemType === 'CourseDetailPage' || itemType === 'ProgrammeDetailPage') {
        if (start.isSame(end, 'day')) {
            return `${start.format('ddd, D MMM YYYY')} <br/> ${start.format('HH:mm')} – ${end.format('HH:mm')}`;
        } else {
            return `${start.format('ddd, D MMM YYYY')} – <br/> ${end.format('ddd, D MMM YYYY')}`;
        }
    }

    return '';
};
